import React from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import t from "@constants/localization";

interface PaymentInfo {
  label: string;
  amount: string;
}

interface PaymentDetails {
  total_amount: PaymentInfo;
  net_pending_payment_info: PaymentInfo[];
  payment_info: PaymentInfo[];
}

interface PaymentDetailProps {
  payment_details?: PaymentDetails;
  warning_lines?: string[];
}

const PaymentDetail: React.FC<PaymentDetailProps> = ({
  payment_details,
  warning_lines,
}) => {
  const PATH = "screens/MyDeliveries/Overview";

  if (!payment_details) return null;

  return (
    <View style={{ backgroundColor: color.white }}>
      <View style={styles.container}>
        <Text variant="subtitle_16" style={styles.title}>
          {t(`${PATH}/paymentDetails`)}
        </Text>
        {payment_details.total_amount ? (
          <View style={styles.totalAmountContainer}>
            <Text variant="caption_1">
              {payment_details.total_amount.label}
            </Text>
            <Text variant="title_18">
              {payment_details.total_amount.amount}
            </Text>
          </View>
        ) : null}
        {payment_details.net_pending_payment_info &&
        payment_details.net_pending_payment_info.length > 0 ? (
          <View style={styles.pendingSection}>
            {payment_details.net_pending_payment_info.map((item, index) => (
              <View key={index} style={styles.itemContainer}>
                <Text variant="caption_4" style={styles.labelText}>
                  {item.label}
                </Text>
                <Text variant="body_text_3">{item.amount}</Text>
              </View>
            ))}
          </View>
        ) : null}
        {payment_details.payment_info &&
        payment_details.payment_info.length > 0 ? (
          <View style={styles.paymentSection}>
            {payment_details.payment_info.map((item, index) => (
              <View key={index} style={styles.itemContainer}>
                <Text variant="caption_4" style={styles.labelText}>
                  {item.label}
                </Text>
                <Text variant="body_text_3">{item.amount}</Text>
              </View>
            ))}
          </View>
        ) : null}
      </View>
      {warning_lines && warning_lines.length > 0 && (
        <View style={styles.warningContainer}>
          {warning_lines.map((line, index) => (
            <View key={index} style={styles.warningItem}>
              <View style={styles.warningDot} />
              <Text key={index} variant="caption_2" style={styles.warningText}>
                {line}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    borderRadius: 12,
    padding: 12,
    margin: 16,
    marginVertical: 4,
    borderColor: color.primaryBg,
    borderWidth: 1,
  },
  title: {
    marginBottom: 8,
    color: color.black,
  },
  totalAmountContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 4,
    paddingHorizontal: 4,
  },
  pendingSection: {
    backgroundColor: color.primaryBg,
    paddingVertical: 8,
    paddingHorizontal: 8,
    borderRadius: 8,
    marginBottom: 8,
  },
  paymentSection: {
    backgroundColor: color.primaryBg,
    paddingVertical: 8,
    paddingHorizontal: 8,
    borderRadius: 8,
  },
  itemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 4,
  },
  labelText: {
    color: color.black06,
  },
  warningContainer: {
    backgroundColor: "rgba(255, 77, 79, 0.08)",
    borderRadius: 10,
    padding: 12,
    paddingVertical: 5,
    margin: 16,
    marginVertical: 4,
  },
  warningText: {
    color: color.red,
    lineHeight: 20,
  },
  warningDot: {
    width: 5,
    height: 5,
    borderRadius: 4,
    backgroundColor: color.red,
    marginRight: 6,
  },
  warningItem: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default PaymentDetail;
